// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderInvoice_container__IjCa4","section":"OrderInvoice_section__AGEwS"};